module.exports = __webpack_public_path__ + "d1c843f82164b9948e78e37291b94d3d.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/content/assets/Slideshow_04.jpg
// module id = 624
// module chunks = 0